import React from 'react';
import Link from 'next/link';
import { Button, Grid, Paper } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { LinkComponent } from '../../Global/LinkComponents';
import { UpcomingEventsTable } from './EventsTable';
import { EventCard } from './EventsCard';
import useStyles from '../../../assets/jss/dashboardSection-styles';
import { applyOffest } from '../../../utils/dateFormat';

export const EventsSection = (props) => {
  const classes = useStyles(props)();
  const rows = props.data ? props.data
  .map((row) => {
    const formData = JSON.parse(row.form.data);
    const formTitle = formData.title;

    const baseDate = row.form.dueBaseDate === 'SurgeryDate' ? 'surgeryDate' : 'initialVisitDate';
    const dueBase = row.patient[baseDate];
    const due = applyOffest(dueBase, row.form.dueWeeks, row.form.dueMonths, row.form.dueYears);

    return { ...row, formTitle, due };
  })
  .sort((a, b) => a.due - b.due) : [];

  return (
    <Grid item xs={12}>
      <Paper className={classes.sectionWrapper} elevation={0}>
        <Typography component='h2' variant='h6' className={classes.sectionLabel} fontWeight='fontWeightMedium'>
          {'Upcoming Events this Quarter'}
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            {/* Upcoming Events */}
            <UpcomingEventsTable rows={rows} />
            <div className={classes.buttonContainer}>
              <Link href='/entries/upcoming'>
                <Button component={LinkComponent} variant='contained' color='primary' href='/entries/upcoming'>
                  {'View all upcoming entries'}
                </Button>
              </Link>
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            {/* Upcoming Events */}
            <EventCard type='Events' message='Events that still need to be scheduled' count={rows.length} />
            {/* data={events} */}
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};
